/** Presentation metadata for backend contextual action keys (no client-side generation). */

export const RESPONSE_ACTION_ICON_KEYS = {
    view_vdr_files: 'folder',
    open_task_list: 'task',
    open_overdue_tasks: 'task',
    open_irl_list: 'irl',
    open_raid_list: 'raid',
    view_evidence: 'evidence',
    open_source: 'document',
    create_irl: 'irl',
    open_irl: 'irl',
    open_evidence_follow_ups: 'irl',
    add_to_raid: 'raid',
    open_raid_item: 'raid',
    open_risks_signals: 'raid',
    create_observation: 'observation',
    open_observation: 'observation',
    open_key_findings: 'observation',
    create_task: 'task',
    open_task: 'task',
    add_to_action_log: 'action_log',
    open_action_log_item: 'action_log',
    save_to_journal: 'journal',
};

export const RESPONSE_ACTION_DESCRIPTIONS = {
    view_vdr_files: 'Browse project documents',
    open_task_list: 'Review project tasks',
    open_overdue_tasks: 'See overdue work items',
    open_irl_list: 'Open information requests',
    open_raid_list: 'Review risks and issues',
    view_evidence: 'Inspect supporting sources',
    open_source: 'Jump to the cited source',
    create_irl: 'Draft a new information request',
    open_irl: 'Open the related IRL item',
    open_evidence_follow_ups: 'Review evidence follow-ups',
    add_to_raid: 'Log a RAID entry from this answer',
    open_raid_item: 'Open the related RAID item',
    open_risks_signals: 'Review risks and signals',
    create_observation: 'Capture a diligence observation',
    open_observation: 'Open the related observation',
    open_key_findings: 'Review key findings',
    create_task: 'Create a follow-up task',
    open_task: 'Open the related task',
    add_to_action_log: 'Record a decision or action',
    open_action_log_item: 'Open the related log entry',
    save_to_journal: 'Save this answer to Journal',
};

export function resolveActionIconKey(actionKey) {
    return RESPONSE_ACTION_ICON_KEYS[String(actionKey || '')] || 'default';
}

export function resolveActionDescription(action) {
    if (!action?.key) return '';
    return RESPONSE_ACTION_DESCRIPTIONS[action.key] || '';
}

export function isActionExecutable(action, handlers = {}) {
    if (!action?.key) return false;
    if (action.kind === 'navigate') {
        if (action.key === 'view_evidence') return Boolean(handlers.onViewEvidence);
        if (action.key === 'open_source') {
            return Boolean(handlers.onOpenSource || handlers.onViewEvidence);
        }
        if (action.key === 'save_to_journal') return Boolean(handlers.onSaveJournal);
        return Boolean(action.route);
    }
    if (action.kind === 'create') {
        const createKeys = new Set([
            'create_observation',
            'create_task',
            'create_irl',
            'add_to_raid',
            'add_to_action_log',
        ]);
        return createKeys.has(action.key);
    }
    return false;
}

export function listResponseActions(responseActions) {
    if (!responseActions || typeof responseActions !== 'object') return [];
    const actions = [];
    if (responseActions.primary) actions.push({ ...responseActions.primary, slot: 'primary' });
    if (responseActions.secondary) actions.push({ ...responseActions.secondary, slot: 'secondary' });
    return actions;
}
